import { render, staticRenderFns } from "./BannerProductService.vue?vue&type=template&id=29ca4986&scoped=true&"
import script from "./BannerProductService.vue?vue&type=script&lang=js&"
export * from "./BannerProductService.vue?vue&type=script&lang=js&"
import style0 from "./BannerProductService.vue?vue&type=style&index=0&id=29ca4986&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ca4986",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
